import { useParams } from 'react-router-dom';
import '../../../../../../styles/Dashboard.css';
import { useConsultationQuestions } from '../../../../../../hooks/fetchers/useConsultationQuestions/useConsultationQuestions';
import DashboardLayout from '../../../../../commons/DashboardLayout/DashboardLayout';
import DashboardHistoryENTQuestionForm from './DashboardHistoryENTQuestionForm/DashboardHistoryENTQuestionForm';
import moment from 'moment';

export default () => {
  const { consultationId } = useParams();

  const { data } = useConsultationQuestions(parseInt(consultationId as string), {
    enabled: Boolean(consultationId),
  });

  return (
    <DashboardLayout>
      {data?.map(({ question, answers }, index) => (
        <section key={index} className="dashboard__main-row">
          <div className="dashboard-history__question">
            <label>{question.question_text}</label>
            <span>{moment(question.question_created_at).format('lll')}</span>
            <div className="dashboard-history__question-answers">
              {answers?.map(({ answer_text, answer_created_at }, answerIndex) => (
                <div
                  key={`answer#${answerIndex}`}
                  className="dashboard-history__question-answers-item">
                  <p>{`${answer_text}`}</p>
                  <span>{moment(answer_created_at).format('lll')}</span>
                </div>
              ))}
            </div>
          </div>
        </section>
      ))}
      <DashboardHistoryENTQuestionForm consultationId={parseInt(consultationId as string)} />
    </DashboardLayout>
  );
};
